import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NiceSelectModule } from 'ng-nice-select';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Httprequestintercept } from './httpRequests.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoadingScreenComponent } from './loading-screen/loading-screen.component';
import { RestrictRightClickandShortcutDirective } from './restrict-right-clickand-shortcut.directive';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { RegistrationComponent } from './registration/registration.component';
import { ErrorHandler } from '@angular/core';
import { GlobalErrorHandler } from './models/GlobalErrorHandler';
import { initializeApp } from 'firebase/app';
import { environment } from '../environments/environment';
import { appLoaderComponent } from './appLoader/appLoader.component';
import { MatDialogModule } from '@angular/material/dialog';

initializeApp(environment.firebase);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RestrictRightClickandShortcutDirective,
    ForgotpasswordComponent,
    RegistrationComponent,
    appLoaderComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NiceSelectModule,
    DragDropModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    MalihuScrollbarModule.forRoot(),
    MatDialogModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Httprequestintercept,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ],
  entryComponents: [LoadingScreenComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
